export default "__VITE_ASSET__B7Cx9xoV__"